import apiClient from "../api/axiosConfig";

export const getCountriesCurrencies = async (includeAll = false) =>
    apiClient.feesAPI.get(
        `/api/countries-currencies/getCountriesCurrenciesList?all=${includeAll}`,
    );
